import { i18n } from '@lingui/core';
import _ from 'lodash';

import { ROLES } from 'common/constants/general';

export function getLabelForRole(role) {
  const itemLabel = _.find(ROLES, { value: role })?.label;
  return itemLabel ? i18n._(itemLabel) : null;
}
